module.exports = __webpack_public_path__ + "img/chevron-right.3db904c3.svg";